/* eslint-disable compat/compat */
export default (function () {
  return {
    init() {
      const lazyloadImages = document.querySelectorAll('.js-lazy');
      const lazyloadBackgroundImages = document.querySelectorAll('.js-lazy-bg-image');

      if (!lazyloadImages.length && !lazyloadBackgroundImages.length) return;

      if ('loading' in HTMLImageElement.prototype && lazyloadImages.length > 0) {
        lazyloadImages.forEach((image) => {
          spirax.lazyImages.setBrowserLoading(image);
        });
      } else if (lazyloadImages.length > 0) {
        spirax.lazyImages.checkIntersection(lazyloadImages);
      }

      // Cannot do browser level lazy loading on background images
      if (lazyloadBackgroundImages.length) {
        spirax.lazyImages.checkIntersection(lazyloadBackgroundImages);
      }
    },
    observer(images) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove('js-lazy');
            image.classList.remove('js-lazy-bg-image');
            imageObserver.unobserve(image);
          }
        });
      });

      images.forEach((image) => {
        imageObserver.observe(image);
      });
    },
    lazyload(images) {
      let lazyloadThrottleTimeout;
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(() => {
        const scrollTop = window.pageYOffset;
        images.forEach((img) => {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src;
            img.classList.remove('js-lazy');
            img.classList.remove('js-lazy-bg-image');
          }
        });
        if (!images.length) {
          document.removeEventListener('scroll', lazyload);
          window.removeEventListener('resize', lazyload);
          window.removeEventListener('orientationChange', lazyload);
        }
      }, 20);
    },
    setBrowserLoading(image) {
      image.src = image.dataset.src;
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
    },
    checkIntersection(images) {
      if ('IntersectionObserver' in window) {
        spirax.lazyImages.observer(images);
      } else {
        spirax.lazyImages.lazyload(images);
        document.addEventListener('scroll', lazyload);
        window.addEventListener('resize', lazyload);
        window.addEventListener('orientationChange', lazyload);
      }
    },
  };
})();
